// Experiences.js
import React from 'react';
import ExperiencesPage from './ExperiencesPage';

const Experiences = () => {
  return (
    <div>
          <a href="#Experiences" style={{ textDecoration: 'none' }}><ExperiencesPage/></a>
    </div>
  );
};

export default Experiences;
